import {
  CreateCompetitionAlonePriceDto,
  UpdateCompetitionPriceDto,
} from "../types/competition.types";
import { PaymentType } from "../types/payments.types";
import { httpClient } from "./common";
import { ResponseData } from "./types";
import { withApiErrorHandling } from "../APIs/withApiErrorHandling";

export class CompetitionPricesAPI {
  private static readonly API_URL = "/competition_prices";

  public static async getCompetitionPrice(id: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(`${CompetitionPricesAPI.API_URL}/${id}`, true),
      "Error al obtener el precio de la competencia"
    );
  }

  public static async createCompetitionPrice(
    data: CreateCompetitionAlonePriceDto
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.post(CompetitionPricesAPI.API_URL, data, true),
      "Error al crear el precio de la competencia"
    );
  }

  public static async updateCompetitionPrice(
    id: number,
    data: UpdateCompetitionPriceDto
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.patch(`${CompetitionPricesAPI.API_URL}/${id}`, data, true),
      "Error al actualizar el precio de la competencia"
    );
  }

  public static async deleteCompetitionPrice(id: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.delete(`${CompetitionPricesAPI.API_URL}/${id}`, true),
      "Error al eliminar el precio de la competencia"
    );
  }

  public static async getTransferDetails(id: number): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () => httpClient.get(`${CompetitionPricesAPI.API_URL}/${id}/transfer-details`, true),
      "Error al obtener los detalles del pago"
    );
  }

  public static async getCompetitionPrices(
    competitionId: number,
    paymentType: PaymentType
  ): Promise<ResponseData<any>> {
    return withApiErrorHandling(
      () =>
        httpClient.get(
          `${CompetitionPricesAPI.API_URL}/competition/${competitionId}?payment_type=${paymentType}`,
          true
        ),
      "Error al obtener las precios de la competencia"
    );
  }
}
